import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
type SiteLinkProps = {
  to: string;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
  'aria-label'?: string;
};
function isExternal(to: string) {
  return /^(https?:|tel:|sms:|mailto:)/.test(to);
}
export function SiteLink({
  to,
  className,
  children,
  ...rest
}: SiteLinkProps) {
  if (isExternal(to)) {
    return <a href={to} className={className} {...rest} data-id="element-207" data-mp="3h92aw2z3yzq">
        {children}
      </a>;
  }
  return <Link to={to} className={className} {...rest} data-id="element-208" data-mp="8fu24uebcgnn">
      {children}
    </Link>;
}